import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "1) The world's 1st patented eGeeTouch® Smartlocks enable our Luggage Mfr's partner, Distributors & Retailers to create new product line with a strong product portfolio that completely differentiate themselves from their competitors.",
    reply2:
      "2) eGeeTouch® Smart Luggage Locks, delivering significant enhanced values to end user i.e. easy one-touch function and enhanced security, as well as superior built quality, are able to command higher value.",
    reply3:
      "3) With over two decades of R&D and manufacturing expertise, our highly experienced team and own world-class production facility enable competent level of control over Product Quality, Reliability and prompt Delivery.",
    back: "Back",
  },
  ja: {
    reply1:
      "1) 世界初の特許取得済み eGeeTouch® スマート ロックにより、荷物メーカーのパートナーである販売業者および小売業者は、競合他社と完全に差別化できる強力な製品ポートフォリオを備えた新しい製品ラインを作成できます。",
    reply2:
      "2) eGeeTouch® スマート ラゲッジ ロックは、エンド ユーザーに大幅に強化された価値、つまり簡単なワンタッチ機能と強化されたセキュリティ、および優れた構築品質を提供し、より高い価値を要求できます。",
    reply3:
      "3) 20 年以上の研究開発と製造の専門知識を備えた当社の経験豊富なチームと独自の世界クラスの生産施設により、製品の品質、信頼性、迅速な納品を適切なレベルで管理できます。",
    back: "戻る",
  },
  es: {
    reply1:
      "1) Las primeras candados inteligentes eGeeTouch® patentadas del mundo permiten a los distribuidores y minoristas de nuestro fabricante de equipaje crear una nueva línea de productos con una sólida cartera de productos que los diferencia completamente de sus competidores.",
    reply2:
      "2) Las candados inteligentes para equipaje eGeeTouch®, que ofrecen valores mejorados significativos para el usuario final, es decir, función sencilla de un solo toque y seguridad mejorada, así como una calidad de construcción superior, pueden exigir un mayor valor.",
    reply3:
      "3) Con más de dos décadas de experiencia en investigación y desarrollo y fabricación, nuestro equipo altamente experimentado y nuestras propias instalaciones de producción de clase mundial permiten un nivel competente de control sobre la calidad, confiabilidad y entrega rápida del producto.",
    back: "Atrás",
  },
});

class Q26_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <br />
        <br />
        {localizationStrings.reply3}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q26_component;
